module.exports = __webpack_public_path__ + "img/feedback1-1.ae9cc458.jpg";